<template>
  <div v-if="visible" class="browser-mask" @click="handleMaskClick">
    <!-- 修正后的箭头容器 - 右上角直接朝上 -->
    <div class="arrow-container">
        <div class="arrow-head"></div>
        <div class="arrow-line"></div>
    </div>
    
    <!-- 提示内容 -->
    <div class="tip-content">
      <div class="tip-icon">💡</div>
      <h3>{{ title }}</h3>
      <p></p>
      <p style="line-height: 35px;" v-html="message"></p>
      <!-- <button class="confirm-btn" @click="close">知道了</button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserMask',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "支付提示"
    },
    message: {
      type: String,
      default: '请点击右上角<b>"..."</b>，选择<b>"在浏览器打开"</b>以完成支付宝支付'
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    
    handleMaskClick(event) {
      this.close();
      // if (event.target.classList.contains('browser-mask')) {
      //   this.close();
      // }
    }
  }
}
</script>

<style scoped>
.browser-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease;
}

/* 修正后的箭头容器 - 右上角直接朝上 */
.arrow-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 箭头线 - 垂直向上 */
.arrow-line {
  width: 4px;
  height: 80px;
  background: #fff;
  border-radius: 2px;
  animation: pointHead 2s infinite;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin-top: -2px;
}

/* 箭头头部 - 直接朝上的三角形[2](@ref) */
.arrow-head {
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 20px solid #fff;
  animation: pointHead 2s infinite;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

/* 提示内容框 */
.tip-content {
  background: white;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 320px;
  margin: 0 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.4s ease;
  position: relative;
  z-index: 10001;
}

.tip-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.tip-content h3 {
  color: #333;
  margin: 0 0 15px 0;
  font-size: 20px;
  font-weight: 600;
}

.tip-content p {
  color: #666;
  margin: 8px 0;
  line-height: 1.5;
  font-size: 16px;
}

.confirm-btn {
  background: #1677ff;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  transition: background 0.3s;
}

.confirm-btn:hover {
  background: #0957d9;
}

/* 动画定义[3](@ref) */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 垂直方向的箭头动画 */
@keyframes lineExtend {
  0%, 100% {
    height: 60px;
    transform: translateY(0);
  }
  50% {
    height: 70px;
    transform: translateY(-5px);
  }
}

@keyframes pointHead {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .arrow-container {
    top: 15px;
    right: 15px;
  }
  
  .arrow-line {
    height: 50px;
    width: 3px;
  }
  
  .arrow-head {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 16px solid #fff;
  }
  
  @keyframes lineExtend {
    0%, 100% {
      height: 50px;
    }
    50% {
      height: 60px;
    }
  }
  
  .tip-content {
    padding: 25px 20px;
    margin: 0 15px;
    max-width: 280px;
  }
}
</style>